import { render, staticRenderFns } from "./CardInfoV2.vue?vue&type=template&id=4a9c2044&scoped=true&"
import script from "./CardInfoV2.vue?vue&type=script&lang=js&"
export * from "./CardInfoV2.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoV2.vue?vue&type=style&index=0&id=4a9c2044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c2044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9c2044')) {
      api.createRecord('4a9c2044', component.options)
    } else {
      api.reload('4a9c2044', component.options)
    }
    module.hot.accept("./CardInfoV2.vue?vue&type=template&id=4a9c2044&scoped=true&", function () {
      api.rerender('4a9c2044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/CardInfo/Merchant/CardInfoV2.vue"
export default component.exports